import type { SliceStateFromReducer } from 'shared/types';

import type { organizationSlice } from './organization.slice';

type TOrganizationState = SliceStateFromReducer<typeof organizationSlice>;

export const organizationSelector = (state: TOrganizationState) => state.organization.organization;
